import React from 'react';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import './Layout.scss';
import { TopBar } from './TopBar';
import { NavbarContext } from '../../context';
const classnames = require('classnames');

const LayoutContent = ({ children, className }: { children: any; className?: string }) => {
  return (
    <div key='main-container' className={classnames('main-container', className)}>
      {children}
    </div>
  );
};

export class Layout extends React.Component<{}, { isOpen: boolean; toggle() }> {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      toggle: this.toggleNavbar,
    };
  }

  static TopBar = TopBar;
  static Content = LayoutContent;

  toggleNavbar = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  render() {
    return (
      <NavbarContext.Provider value={this.state}>
        <DndProvider backend={HTML5Backend}>{this.props.children}</DndProvider>
      </NavbarContext.Provider>
    );
  }
}
